import React, { Component, Fragment } from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';
import { Container,Row,Col,Button} from 'react-bootstrap'
import Product1 from '../../assets/images/product/cathomis1.png'

class CatHomis extends Component {
     render() {
          return (
               <Fragment>
              <Container fluid={true}  className="BetweenTwoSection">
                  <div className="breadbody">
                <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to=""> Product </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/cat_homis">CAT HOMIS</Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
          
                 
<div className="d-flex justify-content-between align-items-center mb-2">
  <h2 className="section-title text-primary m-0"></h2>


   <Link to="/cathomisLive">
              
            
         
            <Button size="sm" variant="primary">
                 Live Demo
            </Button>
            </Link>
</div>




 <h2 className="section-title text-center mb-2 text-primary">CAT HOMIS</h2>

<p className="text-center mb-3">Hotel & Room Booking Management Software</p>

                   <Row className="p-2">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
          <img  className="product-main"  src={Product1}  alt="ParkEase Dashboard"/>
          <Container  className="my-3">
             
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
          <h5 className="Product-Name">Cat Homis</h5>
          <p>CAT Homis is a comprehensive hotel management software designed to simplify room booking, guest management, and service tracking. It enables hotel staff to efficiently manage reservations, additional services, and billing, ensuring a seamless experience for both guests and administration.</p>
          <div className="">
           <h6> How It Works</h6>
          <h6>   Guest Registration</h6>

              <ul>
               <li>Clients arrive at the hotel reception.</li>
              <li>The receptionist registers the guest and records all necessary details.</li> 
              </ul>

  <h6>Room Assignmentn</h6>
          </div>
          <ul>
               <li>The receptionist assigns a room based on guest preference and availability.</li>
              <li>Additional services such as sauna, steam bath, swimming, drinks, and food orders can be added.</li> 
              </ul>

 <h6>The system automatically calculates the total charges based on:</h6>
          
          <ul>
               <li>Room type and duration of stay</li>
              <li>Selected services and products</li> 
              <li>Receipts and invoices can be printed for the guest.</li>
              </ul>


 <h6>Service Management:</h6>
          
          <ul>
               <li>Tracks guest orders for food, drinks, and amenities</li>
              <li>Ensures all services are accounted for in billing.</li> 
            
              </ul>


          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">Permissions Admin</h6>
          
          <ul>
               <li>Full access to the system.</li>
              <li>Can add or update room charges.</li> 
              <li>Can manage all guest records, bookings, and services.</li>
              <li>Can view reports and dashboards for income, occupancy, and staff performance.</li>
              </ul>
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">Receptionist Permissions</h6>
          
 <ul>
               <li>Registers guests and assigns rooms.</li>
              <li>Can add additional guest services (food, drinks, spa, etc.)..</li> 
              <li>Can generate invoices and print receipts for guests.</li>
              <li>Cannot modify system-wide settings or charges.</li>
              </ul>
          </Col>
     </Row>

</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default CatHomis